<template>
  <div class="passwordReset">
    <PasswordResetForm @password-reset="processPasswordReset" @clear-error="clearError" :error="error" :submitMessage="submitMessage"/>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import PasswordResetForm from '@/components/PasswordResetEntry.vue'

export default {
  name: 'PasswordResetEntry',
  components: { PasswordResetForm },
  data() {
    return {
      error: null,
      count: 0,
      submitMessage: null
    }
  },
  computed: {
    ...mapGetters({ user: 'user/user' }),
    token() {
      return this.$route.params.token || null
    }
  },
  methods: {
    ...mapActions({ passwordResetRequest: 'user/passwordResetRequest', generateOTP: 'user/generateOTP' }),
    async processPasswordReset(payload) {
      const { passwordOne, passwordTwo } = payload
      this.count++
      if (passwordOne !== passwordTwo) {
        this.error = 'Please make sure both passwords match.'
        return
      }
      try {
        await this.passwordResetRequest({ token: this.token, password: passwordOne })
        this.submitMessage = 'Password reset successful. Please return to login.'
        setTimeout(() => {
          this.$router.push('/login')
        }, 3000)
      } catch (err) {
        this.error = err
      }
    },
    clearError() {
      this.error = null
    }
  },
  async mounted() {
    const token = this.token
    await this.generateOTP({ token })
  },
  beforeDestroy() {
    this.$off('password-reset', this.processPasswordReset)
  }
}
</script>

<style lang="scss" scoped>
@import "@/style/variables.scss";
.passwordReset {
  height: 100vh;
  width: 100vw;
  display: flex;
  align-items: center;
  justify-content: center;
  background: $brand-gradient;
}
</style>
